<template>
  <div>
    <label :for="relatedModelUpdate.idForProp('related_model_id')" class="a-select-label">
      Update Which Related Model?</label>
    <a-select :options="linkedModelOptions"
              :id="relatedModelUpdate.idForProp('related_model_id')"
              :key="relatedModelUpdate.related_model_id ? relatedModelUpdate.related_model_id: 'select-models'"
              compress
              @input="clearPropertyUpdates"
              v-model="relatedModelUpdate.related_model_id"></a-select>
    <template v-if="relatedModelUpdate.related_model_id"
              v-for="(propertyUpdate,  index) in relatedModelUpdate.propertyUpdatesArray">
      <panel-item>
        <configure-property-update
          :deleteable="index !== 0"
          :key="propertyUpdate.property_client_id"
          :property-update="propertyUpdate"
          :property-options="updateableProperties"
          v-on:remove="removePropertyUpdate(propertyUpdate)"
        >
          <template v-if="propertyUpdate.property_client_id">
            <component
              v-if="isPickList(propertyUpdate.property_client_id)"
              :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
              :id="`update_value_${propertyUpdate.property_client_id}`"
              :key="`update_value_${propertyUpdate.property_client_id}`"
              class="mb-0"
              :property-client-id="propertyUpdate.property_client_id"
              :object-model="selectedObjectModel"
              v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
              v-model="propertyUpdate.values_to_update_to_array"
            ></component>
            <component
              v-else="propertyUpdate.property_client_id"
              :is="getComponentForPropertyType(getObjectModelPropertyType(propertyUpdate.property_client_id))"
              :id="`update_value_${propertyUpdate.property_client_id}`"
              :key="`update_value_${propertyUpdate.property_client_id}`"
              class="mb-0"
              :property-client-id="propertyUpdate.property_client_id"
              :object-model="selectedObjectModel"
              v-bind="getAdditionalAttrs(getObjectModelProperty(propertyUpdate.property_client_id))"
              v-model="propertyUpdate.value_to_update_to"
            ></component>
          </template>
        </configure-property-update>
      </panel-item>
    </template>
    <panel-actions v-if="relatedModelUpdate.related_model_id">
      <button @click="addPropertyUpdate" type="button" class="btn grey-to-blue full-sz" >
        Add Property to Update
      </button>
    </panel-actions>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ObjectModelTriggerCapability} from "~/models/objectModelTriggers/objectModelTriggerCapability";
  import { IVOptionSetLocal} from "~/interfaces/vSelectInterfaces";
  import ConfigurePropertyUpdate from "~/components/configuration/configure-property-update.vue"
  import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
  import objectModelEntryInputFieldMixin from "~/mixins/objectModelEntries/objectModelEntryInputFieldMixin";
  import propertyUpdateMixin from "../mixins/propertyUpdateMixin";
  import ObjectModel from "~/models/objectModel";
  import RelatedModelUpdate from "~/models/relatedModelUpdate";

  export default Vue.extend({
    mixins: [objectModelEntryInputFieldMixin, propertyUpdateMixin],
    props: {
      relatedModelUpdate: {
        type: Object as () => RelatedModelUpdate,
        required: true
      },
      linkableModels: {
        type: Array,
        required: true
      }
    },
    components: {
      ConfigurePropertyUpdate,
    },
    data: function () {
      return {
        ObjectModelTriggerCapability,
      };
    },
    methods: {
      addPropertyUpdate(): void {
        this.relatedModelUpdate.appendPropertyUpdate()
      },
      clearPropertyUpdates(): void{
        this.relatedModelUpdate.propertyUpdatesArray.forEach((x, index) => index > 0 ? x.destroy : x.property_client_id= null)
      }
    },
    computed: {
      selectedObjectModel(): ObjectModel {
        return this.linkableModels.find(x => x.id === this.relatedModelUpdate.related_model_id);
      },
      updateableProperties() {
        return this.selectedObjectModel.objectModelPropertiesArray
          .filter(x => x.property_type !== ObjectModelPropertyRootType.DerivedField &&
            x.property_type !== ObjectModelPropertyRootType.AutoIncrement &&
            x.property_type !== ObjectModelPropertyRootType.RelationshipCount &&
            x.property_type !== ObjectModelPropertyRootType.MappedProperty &&
            typeof(x.property_type) !== "undefined")
      },
      linkedModelOptions(): IVOptionSetLocal {
        return {
          labelKey: "title",
          valueKey: "id",
          options: this.linkableModels,
        }
      },
    }
  });
</script>